import React from 'react';
import { Link } from 'react-router-dom';

export default function ProductCard({ product, onSeeInRoom, visualizerToken }) {
  return (
    <div className="bg-white rounded-xl border border-gray-100 overflow-hidden shadow-sm hover:shadow-md transition-shadow group flex flex-col font-sans">
      
      {/* Click image to open details */}
      <Link 
        to={`/digital-showroom/${visualizerToken}/product/${product.id}`}
        className="relative aspect-[4/3] bg-gray-100 overflow-hidden cursor-pointer"
      >
        <img
          src={product.image || '/placeholder-tile.webp'}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        {/* Favorite Button */}
      </Link>

      <div className="p-3.5 flex-1 flex flex-col justify-between">
        <Link 
          to={`/digital-showroom/${visualizerToken}/product/${product.id}`}
          className="cursor-pointer"
        >
          <h4 className="text-xs font-bold text-gray-900 uppercase tracking-tight line-clamp-1 hover:text-blue-600 transition-colors">
            {product.name}
          </h4>
          <p className="text-[11px] text-gray-400 mt-0.5 font-medium">
            Size: {product.size}
          </p>
        </Link>

        <button
          type="button"
          onClick={() => onSeeInRoom?.(product)}
          className="mt-3 w-full py-2 px-3 border border-gray-200 rounded-lg text-xs font-semibold text-gray-700 hover:bg-gray-50 hover:border-gray-300 transition-all text-center"
        >
          See this in my room
        </button>
      </div>
    </div>
  );
}